<template>
  <table>
    <thead>
      <tr>
        <th
          v-for="(column, i) in columns"
          :key="`th-${i}`"
          :class="`col-type-${column.type ?? 'any'}`"
        >
          {{ column.label }}
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, i) in data" :key="`tr-${i}`">
        <td
          v-for="(cell, j) in row"
          :key="`td-${i}-${j}`"
          :class="`col-type-${columns[j].type ?? 'any'}`"
        >
          {{ cell }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

export interface TableColumn {
  label: string
  type: string
}

defineProps({
  columns: {
    type: Array as PropType<TableColumn[]>,
    default: () => [],
  },

  data: {
    type: Array as PropType<string[][]>,
    default: () => [],
  },
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

table {
  width: 100%;
  border-collapse: collapse;
  font-size: clamp(0.6rem, 1.25vw, 0.8rem);
  line-height: 1.25em;

  thead tr:nth-child(even),
  tbody tr:nth-child(even) {
    background-color: $color-background-disabled;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: $color-accent;
    color: $color-text-inverted;
  }

  thead th,
  tbody td {
    padding: 0.35em 0.5em;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    font-size: 1em;

    &.col-type-value,
    &.col-type-value-wide {
      text-align: center;
      min-width: min-content;
      max-width: 4em;
    }

    &.col-type-wide,
    &.col-type-value-wide {
      @media screen and (max-width: $break-point-tablet) {
        display: none;
      }
    }
  }

  thead th:first-child,
  tbody td:first-child {
    max-width: fit-content;
  }
}
</style>
